import moment from "moment";
import "moment/locale/es";
import { useEffect, useState } from "react";
import Barcode from "react-barcode";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  mostraAlertaError,
  mostraAlertaOk
} from "../../../componentes/alerts/sweetAlert";
import { AxiosImagen } from "../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../componentes/axios/ErroresPeticion";
import Card from "../../../componentes/contenedores/Card";
import Dropzone from "../../../componentes/imagenes/Dropzone";
import Page from "../../../componentes/plantilla/Page";
import {
  ProductosGuardar,
  ProductosListar
} from "../../../configuracion/apiUrls";
import {
  regexCODE,
  regexDescripcion,
  regexEntero,
  regexNombre
} from "../../../configuracion/validaciones";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
moment.locale("es");
const MAX_IMAGENES = 5;

const NuevoProducto = () => {
  const { listaTiposProductos, setListaProductos, ActualizarLista, listaInventariosTipos } = useContextEmpleado();
  const [nuevasImagenes, setNuevasImagenes] = useState([]);

  const [formularioProducto, setFormularioProducto] = useState({
    id: null,
    nombre: "",
    codigo: "000000000000",
    descripcion: "",
    caracteristicas: "",
    tipo: "",
    impuesto: null,
    productoTipoId: null,
    imagenes: [{ imagen: "" }],
    estado: "Disponible",
    puntoReorden: 1,
    lotes: {
      nombre_lote: "",
      fecha_ingreso: moment().format("YYYY-MM-DD"),
      costo: "",
      precio: "",
      utilidad: "0.00",
      estado: "Disponible",
      cantidad: "",
      existencia: "",
      enPedido: 0,
    },
    lotesPrecios: [],
    lotesInventario: [],
  });

  const tipos = listaTiposProductos
    ? listaTiposProductos.map((f) => ({
      value: f.id,
      label: f.nombre,
    }))
    : [];

  const impuestos = [
    {
      value: "Exento",
      label: "Exento",
      otro: "0",
    },
    {
      value: "15%",
      label: "15%",
      otro: "0.15",
    },
    {
      value: "18%",
      label: "18%",
      otro: "0.18",
    },
  ];

  const tipo = [
    {
      value: "General",
      label: "General",
      otro: "General",
    },
    {
      value: "Servicio",
      label: "Servicio",
      otro: "Servicio",
    },
  ];

  const datos = {
    titulo: {
      titulo: "Nuevo producto",
      url: "/app/admin/productos/nuevo",
      tituloUrl: "productos",
      nombreUrl: "nuevo",
    },
  };

  const [errorNombre, setErrorNombre] = useState(false);
  const [errorCodigo, setErrorCodigo] = useState(false);
  const [errorDescripcion, setErrorDescripcion] = useState(false);
  const [errorReorden, setErrorReorden] = useState(false);
  const [errorProductoTipoId, setErrorProductoTipoId] = useState(false);
  const [dropzoneKey, setDropzoneKey] = useState(Date.now());
  const excedeLimite = nuevasImagenes.length > MAX_IMAGENES;

  const [errorLoteFechaIngreso, setErrorLoteFechaIngreso] = useState(false);
  const [errorLoteCosto, setErrorLoteCosto] = useState(false);
  const [errorLotePrecio, setErrorLotePrecio] = useState(false);
  const [errorLoteCantidad, setErrorLoteCantidad] = useState(false);
  const [errorLoteExistencia, setErrorLoteExistencia] = useState(false);
  const [errorLotesInventario, setErrorLotesInventario] = useState(false);
  const [errorLotesPrecios, setErrorLotesPrecios] = useState(false);

  useEffect(() => {
    const newExistenciaLote = formularioProducto.lotes.cantidad;
    if (newExistenciaLote !== formularioProducto.lotes.existencia) {
      setFormularioProducto(prev => ({
        ...prev,
        lotes: {
          ...prev.lotes,
          existencia: newExistenciaLote,
        },
      }));
    }

    setErrorNombre(!regexNombre.test(formularioProducto.nombre));
    setErrorDescripcion(!regexDescripcion.test(formularioProducto.descripcion));
    setErrorProductoTipoId(!regexEntero.test(formularioProducto.productoTipoId));
    setErrorCodigo(!regexCODE.test(formularioProducto.codigo));
    setErrorReorden(!regexEntero.test(formularioProducto.puntoReorden));

    setErrorLoteFechaIngreso(!formularioProducto.lotes.fecha_ingreso);
    setErrorLoteCosto(isNaN(parseFloat(formularioProducto.lotes.costo)) || parseFloat(formularioProducto.lotes.costo) < 0);
    setErrorLotePrecio(isNaN(parseFloat(formularioProducto.lotes.precio)) || parseFloat(formularioProducto.lotes.precio) < 0);
    setErrorLoteCantidad(!regexEntero.test(formularioProducto.lotes.cantidad) || parseInt(formularioProducto.lotes.cantidad) <= 0);
    setErrorLoteExistencia(!regexEntero.test(formularioProducto.lotes.existencia) || parseInt(formularioProducto.lotes.existencia) < 0);

    const totalExistenciaLote = parseInt(formularioProducto.lotes.existencia) || 0;
    const totalAsignado = formularioProducto.lotesInventario.reduce((sum, item) => {
      return sum + (parseInt(item.existencia) || 0);
    }, 0);

    const totalAsignacionExceeded = totalAsignado > totalExistenciaLote;

    const errorInRows = formularioProducto.lotesInventario.some(item => {
      const existencia = parseInt(item.existencia);
      return existencia < 0 || !item.inventarioTipoId;
    });

    setErrorLotesInventario(errorInRows || totalAsignacionExceeded);

    const errorInLotesPrecios = formularioProducto.lotesPrecios.some(item => {
      const cantidad = parseInt(item.cantidad);
      const precio = parseFloat(item.precio);
      const cantidadInvalida = (!Number.isInteger(cantidad) || cantidad < 1);
      const precioInvalido = (isNaN(precio) || precio < 0);

      return cantidadInvalida || precioInvalido;
    });

    setErrorLotesPrecios(errorInLotesPrecios);
  }, [formularioProducto]);

  useEffect(() => {
    const precio = parseFloat(formularioProducto.lotes.precio) || 0;
    const costo = parseFloat(formularioProducto.lotes.costo) || 0;
    const calculatedUtilidad = (precio - costo).toFixed(2);

    if (calculatedUtilidad !== formularioProducto.lotes.utilidad) {
      setFormularioProducto(prev => ({
        ...prev,
        lotes: {
          ...prev.lotes,
          utilidad: calculatedUtilidad,
        },
      }));
    }
  }, [formularioProducto.lotes.precio, formularioProducto.lotes.costo, formularioProducto.lotes.utilidad]);

  const manejadorProducto = (event) => {
    setFormularioProducto({
      ...formularioProducto,
      [event.target.name]: event.target.value,
    });
  };

  const manejadorlotes = (event) => {
    const { name, value } = event.target;
    setFormularioProducto((prev) => ({
      ...prev,
      lotes: {
        ...prev.lotes,
        [name]: value,
      },
    }));
  };

  const agregarLotePrecio = () => {
    setFormularioProducto((prev) => ({
      ...prev,
      lotesPrecios: [
        ...(prev.lotesPrecios || []),
        { cantidad: "", precio: "" },
      ],
    }));
  };

  const eliminarLotePrecio = (index) => {
    setFormularioProducto((prev) => {
      const arr = [...(prev.lotesPrecios || [])];
      arr.splice(index, 1);
      return { ...prev, lotesPrecios: arr };
    });
  };

  const handleLotePrecioChange = (index, field, value) => {
    setFormularioProducto((prev) => {
      const arr = (prev.lotesPrecios || []).map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      );
      return { ...prev, lotesPrecios: arr };
    });
  };

  const agregarLoteInventario = () => {
    setFormularioProducto((prev) => ({
      ...prev,
      lotesInventario: [
        ...(prev.lotesInventario || []),
        { existencia: 0, inventarioTipoId: "", estado: "Activo" },
      ],
    }));
  };

  const eliminarLoteInventario = (index) => {
    setFormularioProducto((prev) => {
      const arr = [...(prev.lotesInventario || [])];
      arr.splice(index, 1);
      return { ...prev, lotesInventario: arr };
    });
  };

  const handleLoteInventarioChange = (index, field, value) => {
    setFormularioProducto((prev) => {
      const arr = (prev.lotesInventario || []).map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      );
      const finalValue = field === 'existencia' ? (value === "" ? "" : Number(value)) : value;
      return { ...prev, lotesInventario: arr };
    });
  };

  const BotonGuardar = () => {
    return (
      <>
        <button
          type="button"
          className="btn btn-success mr-3"
          onClick={guardarProducto}
          disabled={excedeLimite || errorLotesInventario || errorLotesPrecios}
        >
          Guardar
        </button>
        <button
          type="button"
          className="btn btn-warning mr-3"
          onClick={limpiarDatos}
        >
          Limpiar
        </button>
      </>
    );
  };

  const limpiarDatos = () => {
    setFormularioProducto({
      id: null,
      nombre: "",
      codigo: "000000000000",
      descripcion: "",
      caracteristicas: "",
      tipo: "",
      impuesto: null,
      productoTipoId: null,
      imagenes: [{ imagen: "" }],
      estado: "Disponible",
      puntoReorden: 1,
      lotes: {
        nombre_lote: "",
        fecha_ingreso: moment().format("YYYY-MM-DD"),
        costo: "",
        precio: "",
        utilidad: "0.00",
        estado: "Disponible",
        cantidad: "",
        existencia: "",
        enPedido: 0,
      },
      lotesPrecios: [],
      lotesInventario: [],
    });
    setErrorNombre(false);
    setErrorDescripcion(false);
    setNuevasImagenes([]);
    setErrorProductoTipoId(false);
    setErrorCodigo(false);
    setErrorReorden(false);
    setDropzoneKey(Date.now());
    setErrorLoteFechaIngreso(false);
    setErrorLoteCosto(false);
    setErrorLotePrecio(false);
    setErrorLoteCantidad(false);
    setErrorLoteExistencia(false);
    setErrorLotesInventario(false);
    setErrorLotesPrecios(false);
  };

  const guardarProducto = async () => {
    if (excedeLimite) {
      mostraAlertaError(`No puedes subir más de ${MAX_IMAGENES} imágenes.`);
      return;
    }
    if (
      errorNombre ||
      errorDescripcion ||
      errorProductoTipoId ||
      errorCodigo ||
      errorReorden ||
      errorLoteFechaIngreso ||
      errorLoteCosto ||
      errorLotePrecio ||
      errorLoteCantidad ||
      errorLoteExistencia ||
      errorLotesInventario ||
      errorLotesPrecios
    ) {
      mostraAlertaError("Existen errores en los datos");
      return;
    }

    try {
      const formData = new FormData();

      nuevasImagenes.forEach((file) => {
        formData.append("imagenes", file);
      });

      formData.append("nombre", formularioProducto.nombre);
      formData.append("descripcion", formularioProducto.descripcion);
      formData.append("caracteristicas", formularioProducto.caracteristicas || "");
      formData.append("tipo", formularioProducto.tipo);
      formData.append("precio", formularioProducto.lotes.precio);
      formData.append("costo", formularioProducto.lotes.costo);
      formData.append("existencia", formularioProducto.lotes.existencia);
      formData.append("impuesto", formularioProducto.impuesto || "");
      formData.append("productoTipoId", formularioProducto.productoTipoId);
      formData.append("estado", formularioProducto.estado);
      formData.append("codigo", formularioProducto.codigo);
      formData.append("puntoReorden", formularioProducto.puntoReorden);

      if (formularioProducto.lotes) {
        const lotes = {
          nombre_lote: formularioProducto.lotes.nombre_lote,
          fecha_ingreso: moment(formularioProducto.lotes.fecha_ingreso).format("YYYY-MM-DD"),
          costo: formularioProducto.lotes.costo,
          precio: formularioProducto.lotes.precio,
          utilidad: formularioProducto.lotes.utilidad,
          estado: formularioProducto.lotes.estado,
          cantidad: formularioProducto.lotes.cantidad,
          existencia: formularioProducto.lotes.existencia,
          enPedido: formularioProducto.lotes.enPedido || 0,
        };
        formData.append("lotes", JSON.stringify(lotes));
      }

      if (formularioProducto.lotesPrecios?.length > 0) {
        formularioProducto.lotesPrecios.forEach((item, index) => {
          formData.append(`lotesPrecios[${index}][cantidad]`, item.cantidad);
          formData.append(`lotesPrecios[${index}][precio]`, item.precio);
        });
      }
      if (formularioProducto.lotesInventario?.length > 0) {
        formularioProducto.lotesInventario.forEach((item, index) => {
          formData.append(`lotesInventario[${index}][existencia]`, item.existencia);
          formData.append(`lotesInventario[${index}][inventarioTipoId]`, item.inventarioTipoId);
          formData.append(`lotesInventario[${index}][estado]`, item.estado);
        });
      }

      await AxiosImagen.post(ProductosGuardar, formData);

      limpiarDatos();
      ActualizarLista(ProductosListar, setListaProductos);
      mostraAlertaOk("Producto guardado correctamente");
    } catch (er) {
      console.error("Error al guardar:", er);
      ErroresPeticion(er);
    }
  };

  return (
    <Page datos={datos}>
      <Card pie={<BotonGuardar />}>
        <h4>Información General del Producto</h4>
        <hr />
        <div className="row mb-3">
          <div className="col-md-4 col-sm-12">
            <label htmlFor="codigoProducto">Código del producto</label>
            <div className="form-group">
              <input
                type="text"
                className={`form-control ${errorCodigo ? "is-invalid" : ""}`}
                id="codigoProducto"
                placeholder="Ingrese el código de barra"
                name="codigo"
                value={formularioProducto.codigo}
                onChange={manejadorProducto}
              />
              {errorCodigo && (
                <div className="invalid-feedback">
                  El código puede usar números y letras.
                </div>
              )}
            </div>
          </div>
          <div className="col-md-8 col-sm-12 d-flex align-items-center justify-content-center">
            <div className="form-group w-100 text-center">
              {errorCodigo ? (
                <p className="text-muted mt-3">Ingrese un código válido para generar el código de barras.</p>
              ) : (
                <Barcode
                  value={formularioProducto.codigo}
                  format="CODE128"
                  width={2}
                  height={50}
                  displayValue={true}
                />
              )}
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="nombreProducto">Nombre del producto</label>
              <input
                type="text"
                className={`form-control ${errorNombre ? "is-invalid" : ""}`}
                id="nombreProducto"
                placeholder="Ingrese el nombre del producto"
                name="nombre"
                value={formularioProducto.nombre}
                onChange={manejadorProducto}
              />
              {errorNombre && (
                <div className="invalid-feedback">
                  El nombre de producto tiene que tener 3 caracteres.
                </div>
              )}
            </div>
          </div>

          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="descripcionProducto">Descripción del producto</label>
              <input
                type="text"
                className={`form-control ${errorDescripcion ? "is-invalid" : ""}`}
                id="descripcionProducto"
                placeholder="Descripción detallada del producto"
                name="descripcion"
                value={formularioProducto.descripcion}
                onChange={manejadorProducto}
              />
              {errorDescripcion && (
                <div className="invalid-feedback">
                  La descripción tiene que tener 10 caracteres.
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-8 col-sm-12">
            <div className="form-group">
              <label htmlFor="caracteristicasProducto">Características</label>
              <textarea
                rows={3}
                className="form-control"
                id="caracteristicasProducto"
                placeholder="Característica 1&#10;Característica 2&#10;Característica 3"
                name="caracteristicas"
                value={formularioProducto.caracteristicas}
                onChange={manejadorProducto}
              />
              <small className="form-text text-muted">
                Ingrese cada característica en una nueva línea.
              </small>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="tipoProducto">Tipo de producto</label>
              <select
                className="form-control select2bs4"
                style={{ width: "100%" }}
                id="tipoProducto"
                value={formularioProducto.tipo || ""}
                onChange={(e) => {
                  setFormularioProducto({
                    ...formularioProducto,
                    tipo: e.target.value,
                  });
                }}
              >
                <option value="">Seleccione el tipo</option>
                {tipo.map((tipo) => (
                  <option key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="categoriaProducto">Categoría del producto</label>
              <select
                className="form-control select2bs4"
                style={{ width: "100%" }}
                id="categoriaProducto"
                value={formularioProducto.productoTipoId || ""}
                onChange={(e) => {
                  setFormularioProducto({
                    ...formularioProducto,
                    productoTipoId: e.target.value,
                  });
                }}
              >
                <option value="">Seleccione una categoría</option>
                {tipos.map((tipo) => (
                  <option key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="impuestoProducto">Impuesto aplicable</label>
              <select
                className="form-control select2bs4"
                style={{ width: "100%" }}
                id="impuestoProducto"
                value={formularioProducto.impuesto || ""}
                onChange={(e) => {
                  setFormularioProducto({
                    ...formularioProducto,
                    impuesto: e.target.value,
                  });
                }}
              >
                <option value="">Seleccione el impuesto</option>
                {impuestos.map((impuesto) => (
                  <option key={impuesto.value} value={impuesto.value}>
                    {impuesto.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="estadoProductoSwitch">Estado</label>
              <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mt-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="estadoProductoSwitch"
                  name="estado"
                  checked={formularioProducto.estado === "Disponible"}
                  onChange={(event) => {
                    setFormularioProducto({
                      ...formularioProducto,
                      estado: event.target.checked ? "Disponible" : "Agotado",
                    });
                  }}
                />
                <label className="custom-control-label" htmlFor="estadoProductoSwitch">
                  {formularioProducto.estado === "Disponible" ? "Disponible" : "Agotado"}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="puntoReorden">Punto de reorden</label>
              <input
                type="number"
                step="1"
                className={`form-control ${errorReorden ? "is-invalid" : ""}`}
                id="puntoReorden"
                placeholder="Nivel mínimo para reordenar"
                name="puntoReorden"
                value={formularioProducto.puntoReorden}
                onChange={manejadorProducto}
              />
              {errorReorden && (
                <div className="invalid-feedback">No permite campos vacíos.</div>
              )}
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <label htmlFor="imagenesProducto">Imagenes del producto</label>
          <div className="col-12">
            <Dropzone
              key={dropzoneKey}
              max={MAX_IMAGENES}
              files={nuevasImagenes}
              setFiles={setNuevasImagenes}
            />
          </div>
          <div className="col-12">
            <p className="mt-2 text-muted">Tienes {nuevasImagenes.length} de {MAX_IMAGENES} imágenes.</p>
            {excedeLimite && <p className="text-danger">Ha excedido el límite de imágenes.</p>}
          </div>
        </div>
        <h4 className="mt-4">Gestión de Inventario</h4>
        <hr />
        <div className="row mb-3">
          <div className="col-md-6 mb-3">
            <div className="form-group">
              <label htmlFor="nombreLote">Nombre del lote</label>
              <input
                type="text"
                className="form-control"
                id="nombreLote"
                placeholder="Ej. Lote A1"
                name="nombre_lote"
                value={formularioProducto.lotes.nombre_lote}
                onChange={(e) => {
                  setFormularioProducto({
                    ...formularioProducto,
                    lotes: {
                      ...formularioProducto.lotes,
                      nombre_lote: e.target.value,
                    },
                  });
                }}
              />
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="fechaIngresoLote">Fecha de ingreso</label>
              <DatePicker
                selected={moment(formularioProducto.lotes.fecha_ingreso).toDate()}
                onChange={(date) =>
                  setFormularioProducto({
                    ...formularioProducto,
                    lotes: {
                      ...formularioProducto.lotes,
                      fecha_ingreso: moment(date).format("YYYY-MM-DD"),
                    },
                  })
                }
                dateFormat="yyyy-MM-dd"
                className="form-control"
                wrapperClassName="w-100"
                id="fechaIngresoLote"
              />
              {errorLoteFechaIngreso && (
                <div className="invalid-feedback">
                  La fecha de ingreso es obligatoria.
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="costoLote">Costo del lote</label>
              <input
                type="number"
                step="0.01"
                className={`form-control ${errorLoteCosto ? "is-invalid" : ""}`}
                id="costoLote"
                placeholder="Costo total del lote"
                name="costo"
                value={formularioProducto.lotes.costo}
                onChange={manejadorlotes}
              />
              {errorLoteCosto && (
                <div className="invalid-feedback">
                  El costo del lote es obligatorio y debe ser un número decimal.
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="precioLote">Precio del lote</label>
              <input
                type="number"
                step="0.01"
                className={`form-control ${errorLotePrecio ? "is-invalid" : ""}`}
                id="precioLote"
                placeholder="Precio de venta del lote"
                name="precio"
                value={formularioProducto.lotes.precio}
                onChange={manejadorlotes}
              />
              {errorLotePrecio && (
                <div className="invalid-feedback">
                  El precio del lote es obligatorio y debe ser un número decimal.
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="utilidadLote">Utilidad del lote</label>
              <input
                type="number"
                step="0.01"
                className="form-control"
                id="utilidadLote"
                placeholder="Utilidad calculada"
                name="utilidad"
                value={formularioProducto.lotes.utilidad}
                readOnly
              />
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="cantidadLote">Cantidad del lote</label>
              <input
                type="number"
                step="1"
                className={`form-control ${errorLoteCantidad ? "is-invalid" : ""}`}
                id="cantidadLote"
                placeholder="Cantidad total en este lote"
                name="cantidad"
                value={formularioProducto.lotes.cantidad}
                onChange={manejadorlotes}
              />
              {errorLoteCantidad && (
                <div className="invalid-feedback">
                  La cantidad del lote es obligatoria y debe ser un número entero.
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="existenciaLote">Existencia del lote</label>
              <input
                type="number"
                step="1"
                className={`form-control ${errorLoteExistencia ? "is-invalid" : ""}`}
                id="existenciaLote"
                placeholder="Existencia actual del lote"
                name="existencia"
                value={formularioProducto.lotes.existencia}
                readOnly
              />
              {errorLoteExistencia && (
                <div className="invalid-feedback">
                  La existencia del lote es obligatoria y debe ser un número entero.
                </div>
              )}
              <small className="form-text text-muted">
                La existencia actual se sincroniza con la Cantidad del lote.
              </small>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="estadoLote">Estado del lote</label>
              <select
                className="form-control"
                id="estadoLote"
                name="estado"
                value={formularioProducto.lotes.estado}
                onChange={manejadorlotes}
              >
                <option value="Disponible">Disponible</option>
                <option value="Agotado">Agotado</option>
              </select>
            </div>
          </div>
        </div>
        <h5 className="mt-4 pb-2 border-bottom text-muted">
          <i className="fas fa-money-bill-wave me-2 mx-2"></i> Precios por mayoreo
        </h5>
        <div className="row mb-4">
          <div className="col-12">
            <button
              className={`btn btn-sm ${errorLotesPrecios ? 'btn-danger' : 'btn-outline-secondary'} me-2 mb-3`}
              onClick={agregarLotePrecio}
            >
              <i className="fas fa-plus me-2"></i> Agregar nivel de precio
            </button>
            <div className="alert alert-secondary p-2 mb-3 d-flex align-items-center">
              <i className="fas fa-tags me-3 fa-lg text-muted"></i>
              <p className="mb-0">
                <strong>Niveles de precio por volumen definidos:</strong>&nbsp;
                <span className="badge bg-dark">
                  {formularioProducto.lotesPrecios.length}
                  &nbsp;niveles
                </span>
              </p>
            </div>

            {formularioProducto.lotesPrecios.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered table-sm">
                  <thead className="thead-light">
                    <tr>
                      <th style={{ width: '30%' }}>Cantidad Mínima</th>
                      <th style={{ width: '40%' }}>Precio por Unidad</th>
                      <th style={{ width: '15%' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formularioProducto.lotesPrecios.map((item, idx) => {
                      const cantidadInvalida = (!Number.isInteger(parseInt(item.cantidad)) || parseInt(item.cantidad) < 1) && item.cantidad !== "";
                      const precioInvalido = (isNaN(parseFloat(item.precio)) || parseFloat(item.precio) < 0) && item.precio !== "";

                      return (
                        <tr key={idx} className={cantidadInvalida || precioInvalido || item.cantidad === "" || item.precio === "" ? 'table-warning' : ''}>
                          <td>
                            <input
                              type="number"
                              className={`form-control form-control-sm ${cantidadInvalida ? "is-invalid" : ""}`}
                              min="1"
                              value={item.cantidad}
                              onChange={(e) =>
                                handleLotePrecioChange(idx, "cantidad", e.target.value)
                              }
                            />
                            {cantidadInvalida && (
                              <div className="invalid-feedback">
                                Cantidad inválida
                              </div>
                            )}
                          </td>
                          <td>
                            <input
                              type="number"
                              step="0.01"
                              className={`form-control form-control-sm ${precioInvalido ? "is-invalid" : ""}`}
                              value={item.precio}
                              onChange={(e) =>
                                handleLotePrecioChange(idx, "precio", e.target.value)
                              }
                            />
                            {precioInvalido && (
                              <div className="invalid-feedback">
                                Precio inválido
                              </div>
                            )}
                          </td>
                          <td className="text-center">
                            <button
                              type="button"
                              className="btn btn-sm btn-light text-danger"
                              onClick={() => eliminarLotePrecio(idx)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="alert alert-light border text-muted">
                <i className="fas fa-info-circle me-2"></i>
                No hay precios por volumen definidos.
              </div>
            )}
          </div>
        </div>
        <h5 className="mt-4 pb-2 border-bottom text-muted">
          <i className="fas fa-boxes me-2 mx-2"></i> Asignación de inventario del lote
        </h5>
        <div className="row mb-4">
          <div className="col-12">
            <button
              className={`btn btn-sm ${errorLotesInventario ? 'btn-danger' : 'btn-outline-secondary'} me-2 mb-3`}
              onClick={agregarLoteInventario}
            >
              <i className="fas fa-plus me-2"></i> Asignar ubicación
            </button>

            <div className="alert alert-secondary p-2 mb-3 d-flex align-items-center">
              <i className="fas fa-box-open me-3 fa-lg text-muted"></i>
              <p className="mb-0">
                <strong>Existencia total del lote disponible para asignación:</strong>&nbsp;
                <span className="badge bg-dark">
                  {
                    (parseInt(formularioProducto.lotes.existencia) || 0) -
                    formularioProducto.lotesInventario.reduce((sum, item) => sum + (parseInt(item.existencia) || 0), 0)
                  }
                  &nbsp;unidades
                </span>
              </p>
            </div>
            {formularioProducto.lotesInventario.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered table-sm">
                  <thead className="thead-light">
                    <tr>
                      <th style={{ width: '20%' }}>Unidades</th>
                      <th style={{ width: '40%' }}>Ubicación (Tipo de Inventario)</th>
                      <th style={{ width: '25%' }}>Estado</th>
                      <th style={{ width: '15%' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formularioProducto.lotesInventario.map((item, idx) => {
                      const existenciaAsignada = parseInt(item.existencia) || 0;
                      const existenciaTotal = parseInt(formularioProducto.lotes.existencia) || 0;
                      const totalAsignadoPrevia = formularioProducto.lotesInventario.filter((_, i) => i !== idx).reduce((sum, i) => sum + (parseInt(i.existencia) || 0), 0);
                      const existenciaDisponible = existenciaTotal - totalAsignadoPrevia;

                      const existenciaInvalida = (existenciaAsignada < 0 || item.existencia === "") || (existenciaAsignada > existenciaDisponible);
                      const tipoInvalido = item.inventarioTipoId === "";

                      return (
                        <tr key={idx} className={existenciaInvalida || tipoInvalido ? 'table-warning' : ''}>
                          <td>
                            <input
                              type="number"
                              className={`form-control form-control-sm ${existenciaInvalida ? "is-invalid" : ""}`}
                              min="0"
                              value={item.existencia}
                              onChange={(e) => handleLoteInventarioChange(idx, "existencia", e.target.value)}
                            />
                            {existenciaInvalida && (
                              <div className="invalid-feedback">
                                Cantidad inválida o excede el límite.
                              </div>
                            )}
                          </td>
                          <td>
                            <select
                              className={`form-control form-control-sm ${tipoInvalido ? "is-invalid" : ""}`}
                              value={item.inventarioTipoId}
                              onChange={(e) => handleLoteInventarioChange(idx, "inventarioTipoId", e.target.value)}
                            >
                              <option value="">Seleccione tipo</option>
                              {listaInventariosTipos?.map((tipo) => (
                                <option key={tipo.id} value={tipo.id}>
                                  {tipo.nombre}
                                </option>
                              ))}
                            </select>
                            {tipoInvalido && (
                              <div className="invalid-feedback">Seleccione un tipo</div>
                            )}
                          </td>
                          <td>
                            <select
                              className="form-control form-control-sm"
                              value={item.estado}
                              onChange={(e) => handleLoteInventarioChange(idx, "estado", e.target.value)}
                            >
                              <option value="Activo">Activo</option>
                              <option value="Inactivo">Inactivo</option>
                            </select>
                          </td>
                          <td className="text-center">
                            <button
                              type="button"
                              className="btn btn-sm btn-light text-danger"
                              onClick={() => eliminarLoteInventario(idx)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="alert alert-light border text-muted">
                <i className="fas fa-map-marker-alt me-2"></i>
                Asigne unidades del lote a ubicaciones específicas de inventario.
              </div>
            )}
          </div>
        </div>
      </Card>
    </Page>
  );
};

export default NuevoProducto;